import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthState } from './types';
import {
  clearAuthStorage,
  getRolesFromToken,
  getUserFromToken,
} from '../../services/tokenService.ts';

const initialState: AuthState = {
  user: null,
  roles: [],
  accessToken: null,
  homePageUrl: null,
  logoPageUrl: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sessionRefreshed: (
      state,
      action: PayloadAction<{
        accessToken: string;
        homePageUrl?: string | null;
        logoPageUrl?: string | null;
      }>
    ) => {
      state.accessToken = action.payload.accessToken;
      if (action.payload.homePageUrl !== undefined) {
        state.homePageUrl = action.payload.homePageUrl;
      }
      if (action.payload.logoPageUrl !== undefined) {
        state.logoPageUrl = action.payload.logoPageUrl;
      }
      state.isAuthenticated = true;
      state.roles = getRolesFromToken(action.payload.accessToken);

      const user = getUserFromToken(action.payload.accessToken);
      if (user) {
        state.user = user;
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.roles = [];
      state.accessToken = null;
      state.homePageUrl = null;
      state.logoPageUrl = null;
      state.error = null;

      clearAuthStorage();
    },
  },
});

export const { logout, sessionRefreshed } = authSlice.actions;
export default authSlice.reducer;
